import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
  Box,
  Container,
  Link,
  TextField,
  Typography
} from '@mui/material';

import LoadingButton from '../../components/buttons/Button';
import Logo from "../../assets/icons/logo-white.svg";

import {
  LogIn,
  VerifyMfaLogin,
} from '../../redux/actions/authActions';

import "./styles.scss";

const Data = {
  Email: "",
  Password: ""
}

const AuthPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);

  // MFA challenge state — set when /auth/login returns mfa_required
  const [challengeToken, setChallengeToken] = useState(null);
  const [otp, setOtp] = useState("");
  const [useBackupCode, setUseBackupCode] = useState(false);

  useEffect(() => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleLogin = () => {
    const obj = {
      "user_name": formData.Email,
      "password": formData.Password
    }
    dispatch(LogIn(obj, navigate, setLoading, (mfaPayload) => {
      setChallengeToken(mfaPayload.challenge_token);
      setOtp("");
      setUseBackupCode(false);
    }));
  }

  const handleVerifyMfa = () => {
    const obj = {
      challenge_token: challengeToken,
      otp: useBackupCode ? otp.trim().toUpperCase() : otp,
      method: useBackupCode ? "BACKUP_CODE" : "TOTP",
    }
    dispatch(VerifyMfaLogin(obj, navigate, setLoading));
  }

  const handleBackToLogin = () => {
    setChallengeToken(null);
    setOtp("");
    setUseBackupCode(false);
  }

  return (
    <Box>
      <Box className='auth__dackdrop'></Box>
      <Box className='auth__top'>
        <Container maxWidth="lg">
          <Box className='flexCenterSBRow'>
            <img
              src={Logo}
              alt="lusid-logo"
              style={{ width: "140px" }}
              />
            <Typography variant='h5' sx={{ color: "white" }}>
              {"Internal"}
            </Typography>
          </Box>
        </Container>
      </Box>
      <Container maxWidth="lg">
        <Box className="auth flexCenterCenterRow">
          <Box className="auth__content flexCenterCenterRow"
            p={"25px"}>
            {
              !challengeToken
              ?
              // -------- Step 1: email + password --------
              <Box className="flex_CenterColumn" gap={"20px"}>
                <TextField
                  variant="outlined"
                  label="Email"
                  name="Email"
                  placeholder='Enter your email'
                  value={formData.Email}
                  onChange={handleChange}
                  />
                <TextField
                  variant="outlined"
                  label="Password"
                  name="Password"
                  type="password"
                  placeholder='Enter password'
                  value={formData.Password}
                  onChange={handleChange}
                  />
                <LoadingButton
                  variant='contained'
                  loading={loading}
                  onClick={handleLogin}>
                  Login
                </LoadingButton>
              </Box>
              :
              // -------- Step 2: MFA challenge --------
              <Box className="flex_CenterColumn" gap={"15px"}>
                <Typography variant='subtitle2'>
                  Two-factor authentication
                </Typography>
                <Typography variant='body2' color={"grey"} textAlign={"center"}>
                  {
                    useBackupCode
                    ? "Enter one of your saved backup codes."
                    : "Enter the 6-digit code from your authenticator app."
                  }
                </Typography>
                <TextField
                  variant="outlined"
                  label={useBackupCode ? "Backup code" : "6-digit code"}
                  placeholder={useBackupCode ? "XXXXXXXX" : "000000"}
                  value={otp}
                  onChange={(e) => {
                    if (useBackupCode) {
                      setOtp(e.target.value.replace(/[^A-Za-z0-9]/g, "").slice(0, 16));
                    } else {
                      setOtp(e.target.value.replace(/\D/g, "").slice(0, 6));
                    }
                  }}
                  inputProps={{
                    inputMode: useBackupCode ? "text" : "numeric",
                    maxLength: useBackupCode ? 16 : 6,
                    style: { textAlign: "center", letterSpacing: useBackupCode ? "2px" : "8px" }
                  }}
                  />
                <LoadingButton
                  variant='contained'
                  loading={loading}
                  onClick={handleVerifyMfa}>
                  Verify
                </LoadingButton>
                <Link
                  component='button'
                  type='button'
                  onClick={() => {
                    setUseBackupCode(!useBackupCode);
                    setOtp("");
                  }}
                  sx={{ fontSize: "13px", color: "#9aa0a6" }}>
                  {
                    useBackupCode
                    ? "Use authenticator code instead"
                    : "Use a backup code instead"
                  }
                </Link>
                <Link
                  component='button'
                  type='button'
                  onClick={handleBackToLogin}
                  sx={{ fontSize: "13px", color: "#9aa0a6" }}>
                  Back to login
                </Link>
              </Box>
            }
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default AuthPage
